module.exports = __webpack_public_path__ + "static/media/appmale.7e8ada32.png";